var pressClick = {
	
	image_array : [],

	image_index : 0,

	container : '#pressList',

	winW : $(window).width(),

	overlay_container : '#press_img_overlay',

	controls_container : '.press_img_controls',

	press_image_containers : '#pressImg img, #press_img_overlay img',

	init : function() {
		var mysc = $('#pressList_wrapper').myScroller( { listContainer : '#pressList ul' });
		this.setListeners();

		if( this.winW > 479 ) { 
			$('li:first-child a', this.container).trigger('click');
		}

		
	},

	setListeners : function() {
		var self = this;

		$('a', this.container).click(function() {
			self.setImage( $(this) );
	      	
			return false;
	    });


	  	$('.close-btn', this.overlay_container).click(function() {
	    	$( self.overlay_container ).hide();                                  
	    });

	    $('.previous', this.controls_container).on( 'click', function() {
	    	self.movePrevImage();

	    	return false;
	    });

	    $('.next', this.controls_container).on( 'click', function() {
	    	self.moveNextImage();

	    	return false;
	    });
      
        $('body').keydown( function(e) {
            if ((e.keyCode || e.which) == 37) {   
                self.movePrevImage();
            }
            
            if ((e.keyCode || e.which) == 39) {
                self.moveNextImage();
            }   
        });
      
      	$('#press_img_overlay, #press_img_overlay a.img-link').swipe({
          swipeLeft:function(event, direction, distance, duration, fingerCount) { 
            self.moveNextImage();
          },
          swipeRight:function(event, direction, distance, duration, fingerCount) { 
            self.movePrevImage();
          },
          excludedElements: "",
          threshold:75
        });
	},

	setImage : function( _element ) {
		var self = this;
		
		this.image_array = [];

		$( this.controls_container ).hide();
      	
      	$('a', this.container).removeClass('active');
      	_element.addClass('active');
      
       	      	
      	// unwrap if there is an anchor
      	$('#pressImg a img, #press_img_overlay a img').unwrap();

        if ( _element.data('url') ) {
            var url = _element.data('url');
            $(this.press_image_containers).wrap('<a class="img-link" href="' + url + '" target="_blank"/>');
        }

        if ( _element.data('src') ) { 
          	this.image_array = _element.data('src').split(',');
          
        	
	      	$(this.press_image_containers).attr('src', this.image_array[0] )
	        this.image_index = 1;
	       

	        if ( this.image_array.length > 1 ) {
	        	this.setControls();
	        	$('.total', this.controls_container).text( this.image_array.length );
	        	$( this.controls_container ).show();
	        }
            
                  
        }
      
        if ( !this.isWide() ) {
            $('#press_img_overlay').show();
        }
      
	},

	movePrevImage : function() {

		if ( this.image_index > 1 ) {
			this.image_index--;
			this.setControls ();

			$(this.press_image_containers).attr('src', this.image_array[ this.image_index - 1 ] )
	        
		}
	},

	moveNextImage : function() {
		if ( this.image_index < this.image_array.length ) {
			this.image_index++;
			this.setControls ();

			$(this.press_image_containers).attr('src', this.image_array[ this.image_index - 1 ] )
	        
		}
	},

	setControls : function () {
		$('.curr', this.controls_container).text( this.image_index );
	    
	    if ( this.image_index === 1 ) {
	    	$('.previous', this.controls_container).addClass('disabled');
	    }
	    else {
	    	$('.previous', this.controls_container).removeClass('disabled');
	    }    

	    if ( this.image_index === this.image_array.length ) {
	    	$('.next', this.controls_container).addClass('disabled');
	    }	
	    else {
	    	$('.next', this.controls_container).removeClass('disabled');
	    }
	},
  
  	isWide : function() {
		if ($(window).width() > 479) {
			return true;
		} 
      
      	return false;
	}
}